/*! Copyright (c) Safe As Milk. All rights reserved. */
function tabClick(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("js-using-tab");
        window.removeEventListener("keydown", tabClick);
    }
}

window.addEventListener("keydown", tabClick);

window.theme ??= {};

window.theme.wrapRteTables = (rootElement = document) => {
    const wrapTable = (el, wrapper) => {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    };
    rootElement.querySelectorAll(".rte table").forEach((table => {
        if (table.closest(".js-theme-utility-rte-table-wrap")) return;
        const tableWrapper = document.createElement("div");
        tableWrapper.classList.add("js-theme-utility-rte-table-wrap");
        tableWrapper.setAttribute("style", "overflow:auto;-webkit-overflow-scrolling:touch");
        wrapTable(table, tableWrapper);
    }));
};

window.theme.wrapRteTables();

const scrollEndSupported = typeof window === "undefined" ? true : "onscrollend" in window;

if (!scrollEndSupported) {
    import("scrollyfills");
}
//# sourceMappingURL=global.js.map


/* --- Custom Wine Region Accordion (v13 - Final Hybrid) --- */

// --- HELPER FUNCTIONS (Unchanged) ---
function getOpenCountries() {
  const openCountries = sessionStorage.getItem('openWineCountries');
  return openCountries ? JSON.parse(openCountries) : [];
}

function saveOpenCountries(countries) {
  sessionStorage.setItem('openWineCountries', JSON.stringify(countries));
}
// --- END HELPER FUNCTIONS ---


// 1. DEFINE THE FUNCTION
function buildWineAccordion() {
  const summaries = document.querySelectorAll('.collection-sidebar__filter-trigger');
  let filterWrapper = null;
  summaries.forEach(summary => {
    const span = summary.querySelector('span');
    if (span && span.innerText.trim() === 'Wine region') {
      filterWrapper = summary.closest('details');
    }
  });

  if (!filterWrapper) {
    return;
  }
  
  const filterListElement = filterWrapper.querySelector('details-content');
  if (!filterListElement) {
     return;
  }
  
  const originalList = filterListElement.querySelector('ul');
  if (!originalList) {
     return;
  }

  if (originalList.querySelector('.region-filter-group')) {
    return;
  }

  const filterItems = originalList.querySelectorAll('li.collection-sidebar__item');
  if (filterItems.length === 0) {
    return;
  }

  const regionsByCountry = {};

  // --- NEW SECTION 2: STABLE v10 PARSING ---
  // This logic correctly ignores the count.
  filterItems.forEach(item => {
    const label = item.querySelector('label.collection-sidebar__link');
    if (!label) return; 

    let labelText = "";
    
    label.childNodes.forEach(node => {
        if (node.nodeType === 3) { // nodeType === 3 is a plain text node
            labelText += node.textContent;
        }
    });

    labelText = labelText.trim(); 
    const parts = labelText.split(' - ');

    if (parts.length === 2) {
      const country = parts[0].trim();
      const region = parts[1].trim(); 

      if (!regionsByCountry[country]) {
        regionsByCountry[country] = [];
      }
      item.dataset.region = region; 
      regionsByCountry[country].push(item);
    }
  });
  // --- END NEW SECTION 2 ---


  // --- NEW SECTION 3: ROBUST v12 REBUILD ---
  // This non-destructively finds text, even in <strong> tags
  const countryLiElements = [];
  
  for (const country in regionsByCountry) {
    const countryLi = document.createElement('li');
    countryLi.className = 'collection-sidebar__item region-filter-group';

    const countryTitle = document.createElement('div');
    countryTitle.className = 'region-filter-country';
    countryTitle.innerText = country;
    
    const regionList = document.createElement('ul');
    regionList.className = 'region-filter-list';

    regionsByCountry[country].forEach(item => {
      const label = item.querySelector('label.collection-sidebar__link');
      if (label) {
          // --- ROBUST FIX: FINDS TEXT EVEN IN <strong> ---
          const treeWalker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
          let textNode;
          while (textNode = treeWalker.nextNode()) {
              if (textNode.textContent.includes(' - ')) {
                  textNode.textContent = ` ${item.dataset.region} `;
                  break; 
              }
          }
          // --- END ROBUST FIX ---
      }
      regionList.appendChild(item);
    });

    countryLi.appendChild(countryTitle);
    countryLi.appendChild(regionList);
    countryLiElements.push(countryLi);
  }
  // --- END NEW SECTION 3 ---


  // 4. REPLACE THE OLD LIST (Unchanged)
  originalList.innerHTML = '';
  originalList.style.padding = '0'; 
  originalList.style.margin = '0';
  
  countryLiElements.forEach(li => {
    originalList.appendChild(li);
  });

  // 5. RESTORE OPEN STATES (Unchanged)
  const openCountries = getOpenCountries();
  if (openCountries.length > 0) {
    filterWrapper.querySelectorAll('.region-filter-country').forEach(title => {
      const countryName = title.innerText;
      if (openCountries.includes(countryName)) {
        title.classList.add('is-open');
        title.nextElementSibling.classList.add('is-open');
      }
    });
  }

  // 6. ADD CLICK LISTENERS (Unchanged)
  filterWrapper.querySelectorAll('.region-filter-country').forEach(title => {
    title.addEventListener('click', () => {
      title.classList.toggle('is-open');
      title.nextElementSibling.classList.toggle('is-open');

      const countryName = title.innerText;
      let openCountries = getOpenCountries();

      if (title.classList.contains('is-open')) {
        if (!openCountries.includes(countryName)) {
          openCountries.push(countryName);
        }
      } else {
        openCountries = openCountries.filter(c => c !== countryName);
      }
      saveOpenCountries(openCountries);
    });
  });
}

// 7. RUN THE FUNCTION (Unchanged)
document.addEventListener('DOMContentLoaded', buildWineAccordion);

// 8. WATCH FOR CHANGES (THE AJAX FIX) (Unchanged)
const filterForm = document.querySelector('#CollectionFiltersForm');

if (filterForm) {
  const observer = new MutationObserver((mutations) => {
    buildWineAccordion();
  });
  observer.observe(filterForm, { childList: true, subtree: true });
} else {
  console.warn('Could not find #CollectionFiltersForm to attach filter observer.');
  document.addEventListener('click', (e) => {
    if (e.target.closest('details[id*="filter"]')) {
      setTimeout(buildWineAccordion, 500);
    }
  });
}